import { render } from "./CategoryModal.vue?vue&type=template&id=09517c0f"
import script from "./CategoryModal.js?vue&type=script&lang=js"
export * from "./CategoryModal.js?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__